import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { FILTER_PILLS_BASE_CLASSNAME } from './Constants';
import { createFilterPill } from './FilterPill';
createComponents(".".concat(FILTER_PILLS_BASE_CLASSNAME), createFilterPill, NO_PATTERN_BUSINESS_LOGIC);
